module.exports = __webpack_public_path__ + "img/plurk.8bda8ed6.svg";